module.exports = __webpack_public_path__ + "static/media/p2008coveri1.6c500b40.jpg";